import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type MediaRelease from "./MediaRelease";
import type Organisation from "./Organisation";
import type User from "./User";

@Model()
class MediaReleaseAdhocRecipient extends ApplicationRecord {
  static jsonapiType = "media_release_adhoc_recipients";

  @Attr({ persist: false }) createdAt: string;

  @Attr() email: string;

  @Attr() firstName: string;

  @Attr() invalidEmail: boolean;

  @Attr() lastName: string;

  @BelongsTo() mediaRelease: MediaRelease;

  @Attr() mediaReleaseId: number;

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() salutation: string;

  @Attr({ persist: false }) updatedAt: string;

  @BelongsTo() user: User;

  @Attr() userId: number;
}

export default MediaReleaseAdhocRecipient;
